/* Older storefront browsers do not understand @scope. Prefix selectors there
   without ever activating the unscoped description CSS. */
(() => {
  if ('CSSScopeRule' in window) return;

  function splitSelectors(value) {
    const selectors = [];
    let start = 0;
    let depth = 0;
    let quote = '';
    for (let i = 0; i < value.length; i += 1) {
      const char = value[i];
      if (char === '\\') { i += 1; continue; }
      if (quote) { if (char === quote) quote = ''; continue; }
      if (char === '"' || char === "'") { quote = char; continue; }
      if (char === '(' || char === '[') depth += 1;
      if (char === ')' || char === ']') depth -= 1;
      if (char === ',' && depth === 0) {
        selectors.push(value.slice(start, i).trim());
        start = i + 1;
      }
    }
    selectors.push(value.slice(start).trim());
    return selectors.filter(Boolean);
  }

  function scopedRules(rules, scope) {
    return Array.from(rules, rule => {
      if (rule.type === CSSRule.STYLE_RULE) {
        const selectors = splitSelectors(rule.selectorText)
          .map(selector => `${scope} ${selector}`).join(', ');
        return `${selectors} { ${rule.style.cssText} }`;
      }
      if (rule.type === CSSRule.KEYFRAMES_RULE || rule.type === CSSRule.FONT_FACE_RULE) {
        return rule.cssText;
      }
      if (rule.cssRules) {
        const header = rule.cssText.slice(0, rule.cssText.indexOf('{'));
        return `${header} { ${scopedRules(rule.cssRules, scope)} }`;
      }
      return '';
    }).join('\n');
  }

  function initialize(container) {
    container.querySelectorAll('[data-ych-product-details]').forEach(root => {
      const scope = `#${CSS.escape(root.id)}`;
      root.querySelectorAll('style[data-ych-description-style]').forEach(style => {
        if (style.dataset.ychScoped === 'true') return;
        const css = style.textContent.trim();
        const opening = css.indexOf('{');
        const closing = css.lastIndexOf('}');
        if (!css.startsWith('@scope') || opening < 0 || closing <= opening) return;
        const parser = document.createElement('style');
        parser.media = 'not all';
        parser.textContent = css.slice(opening + 1, closing);
        document.head.appendChild(parser);
        try {
          style.textContent = scopedRules(parser.sheet.cssRules, scope);
          style.dataset.ychScoped = 'true';
        } finally {
          parser.remove();
        }
      });
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
